import artistApi from "../apis/artistApi";
import { apiCallBegin, apiCallSuccess, apiCallError } from "./loading";

export const ACTION_TYPES = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    FETCH_ALL_ARTISTS: 'FETCH_ALL_ARTISTS',
    FETCH_WITH_ALBUMS: 'FETCH_WITH_ALBUMS'
}

export const fetchAll = (searchText = '', pageNo = -1, pageSize = -1) => dispatch => {
    dispatch(apiCallBegin());
    return artistApi.artist().fetchAll(searchText, pageNo, pageSize)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_ALL_ARTISTS,
                payload: response.data
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const fetchWithAlbums = (artistIds, searchField, searchText, pageNo, pageSize) => dispatch => {
    dispatch(apiCallBegin());
    return artistApi.artist().fetchWithAlbums(artistIds, searchField, searchText, pageNo, pageSize)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_WITH_ALBUMS,
                payload: response.data
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const create = (newArtist) => dispatch => {
    dispatch(apiCallBegin());
    return artistApi.artist().create(newArtist)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.CREATE,
                payload: { ...newArtist, id: response.data.id }
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const update = (artist) =>  dispatch => {
    dispatch(apiCallBegin());
    return artistApi.artist().update(artist.id, artist)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.UPDATE,
                payload: artist
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}

export const deleteArtist = (id) => dispatch => {
    dispatch(apiCallBegin());
    return artistApi.artist().delete(id)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.DELETE,
                payload: id
            });
            dispatch(apiCallSuccess());
            return Promise.resolve(response);
        })
        .catch(err => {
            dispatch(apiCallError());
            return Promise.reject(err);
        })
}